export type JpLanguageQueryType = 'KR' | 'ENKR' | 'EN'

type JpLanguageSearchParams = Record<string, string | string[] | undefined>

const LANGUAGE_ALIASES: Record<string, JpLanguageQueryType> = {
  KR: 'KR',
  KO: 'KR',
  EN: 'EN',
  ENKR: 'ENKR',
  KREN: 'ENKR',
  BOTH: 'ENKR',
}

const firstValue = (value: string | string[] | undefined) => (Array.isArray(value) ? value[0] : value)

export const resolveJpLanguageQueryType = (
  searchParams: JpLanguageSearchParams,
  allowed: readonly JpLanguageQueryType[],
): JpLanguageQueryType | undefined => {
  const rawValue = firstValue(searchParams.langType) ?? firstValue(searchParams.LANG_TYPE)
  if (!rawValue) {
    return undefined
  }

  const normalized = rawValue
    .trim()
    .toUpperCase()
    .replaceAll(/[_\-\s]/g, '')
  const language = LANGUAGE_ALIASES[normalized]
  return language && allowed.includes(language) ? language : undefined
}
